import { Box } from '@mui/material';
import { InputList, useInputHelper, InputListTemplateProps } from 'framework/form';
import { InputComponentProps } from './types';
import { PositionDropdown } from 'domain/shared/employee';
import { ADDITIONAL_POSITIONS, VIEW_SKILLS_PROPERTIES_VALUES } from '../../../constants';

const PostionInputs = ({
  propertyDetails,
  renderNestedProperties,
  ...props
}: InputListTemplateProps & Pick<InputComponentProps, 'renderNestedProperties'>) => {
  const { getSource } = useInputHelper(props);

  const source = getSource() || '';

  return (
    <Box
      display="grid"
      gridTemplateColumns="repeat(3, 1fr)"
      columnGap="20px"
      maxWidth="680px"
      width="100%"
      sx={{
        '> .MuiFormControl-root': {
          mb: '0px !important',
        },
      }}
    >
      <PositionDropdown
        additionalOptions={[
          {
            value: ADDITIONAL_POSITIONS.GENERAL,
            label: VIEW_SKILLS_PROPERTIES_VALUES.GENERAL,
          },
          {
            value: ADDITIONAL_POSITIONS.SCREENING_INTERVIEW,
            label: VIEW_SKILLS_PROPERTIES_VALUES.SCREENING_INTERVIEW,
          },
        ]}
        isValueEqLabel
        source={`${source}.value`}
        label=""
        placeholder="Specialization"
      />

      {renderNestedProperties?.({
        propertiesSource: `${source}.properties`,
        propertiesShema: propertyDetails.properties,
      })}
      <Box />
    </Box>
  );
};

const PositionListTamplateFiled = ({ source, propertyDetails, renderNestedProperties }: InputComponentProps) => {
  return (
    <InputList
      inputTemplate={PostionInputs}
      maxFields={10}
      minFields={1}
      defaultValue={{
        value: '',
        properties: {},
      }}
      inputProps={{
        propertyDetails,
        renderNestedProperties,
      }}
      source={`${source}.${propertyDetails.propertyName}`}
      addText="Add position"
    />
  );
};

export default PositionListTamplateFiled;
